import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { injectMetadata } from "@waytek/Utilities/global/injectMetadata";
import isEmpty from "lodash/isEmpty";
import React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    id: string;
}

const mapStateToProps = (state: ApplicationState) => {
    const { customSettings } = getSettingsCollection(state);

    return {
        customSettings: customSettings as any,
    };
};

const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const SchemaForOrganization: React.FC<Props> = ({ customSettings, id }) => {
    const seoSchemaOrganizationJson = customSettings.seoSchemaOrganizationJson || null;
    let seojson = null;

    if (!seoSchemaOrganizationJson) {
        return null;
    }

    try {
        seojson = JSON.parse(seoSchemaOrganizationJson);
    } catch (e) {
        return null;
    }

    if (seojson && !isEmpty(seojson)) {
        injectMetadata(JSON.stringify(seojson), id);
    }

    return null;
};

export default connect(mapStateToProps, mapDispatchToProps)(SchemaForOrganization);
